/**
 * Wordmark: märket + typografisk logotyp + ev tagline.
 *
 * Två storlekar:
 *   - hero: stor, för landningsida (märke 56px, ord 2rem)
 *   - inline: liten, för header/footer (märke 32px, ord 1.125rem)
 */

import { LogoMark } from "./LogoMark";

interface LogoWordmarkProps {
  size?: "hero" | "inline";
  withTagline?: boolean;
  className?: string;
}

export function LogoWordmark({
  size = "inline",
  withTagline = false,
  className,
}: LogoWordmarkProps) {
  const markSize = size === "hero" ? 56 : 32;

  return (
    <div className={`logo-wordmark logo-${size} ${className ?? ""}`}>
      <LogoMark size={markSize} />
      <div className="logo-words">
        <span className="logo-brand">
          <span className="logo-brand-dark">batteri</span>
          <span className="logo-brand-green">kalkyl</span>
          <span className="logo-brand-tld">.se</span>
        </span>
        {withTagline && (
          <span className="logo-tagline">
            Se hur mycket du sparar med batteri.
          </span>
        )}
      </div>
    </div>
  );
}
